import uploadshomesidebyside02actionimagetop100TrialLawyerPng from "$lib/data/generated/uploads/home/SideBySide 02/actionImage/top-100-trial-lawyer.png";
import uploadshomesidebyside02imageworkingAtDeskJpg from "$lib/data/generated/uploads/home/SideBySide 02/image/Working at Desk.jpg";

export const uploads = {
  "uploads/home/SideBySide 02/actionImage/top-100-trial-lawyer.png": uploadshomesidebyside02actionimagetop100TrialLawyerPng,
  "uploads/home/SideBySide 02/image/Working at Desk.jpg": uploadshomesidebyside02imageworkingAtDeskJpg
};